import React, { useContext  } from "react";
import { Navigate } from "react-router-dom";

import { UserSettingsContext } from "../../contexts/UserSettingsContext";

// For routes that can only be accessed by authenticated users
function AuthGuard({ children }) {
  const { isAuthenticated } = useContext(UserSettingsContext);

  // Could make a similar guard for H3 admin only pages as we add those

  if (!isAuthenticated) {
    if (window.location.pathname != null && window.location.pathname.length > 1 && !window.location.pathname.startsWith("/h3admin/revenueteams"))
    {
      if (window.location.search && window.location.search.length > 0)
      {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has("destination") && urlParams.get("destination") !== '')
        {
          // Pass along the existing destination (this case may happen e.g. when a h3admin gets unauthorized within a rev team context, then bounced to the rev team, then bounced out)
          return <Navigate to={"/auth/sign-in?destination=" + encodeURIComponent(urlParams.get("destination"))} />;
        }
      }

      return <Navigate to={"/auth/sign-in?destination=" + encodeURIComponent(window.location.pathname + window.location.search + window.location.hash)} />;
    }
    else
    {
      return <Navigate to={"/auth/sign-in"}/>;
    }
  }

  return <React.Fragment>{children}</React.Fragment>;
}

export default AuthGuard;
